import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Button,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { ArrowBack } from "@mui/icons-material";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import image from "../../images/water.jpg"
import ApiCallService from "../../Service/ApiCallService";
import { useParams } from "react-router-dom";
import Spinner from "../../components/common/Spinner";

const NewViewProfilePage = () => {

const { id } = useParams();

const [userData, setUserData] = useState(null)
const [loading, setLoading] = useState(false)

useEffect(() => {
  const userId = id || localStorage.getItem("userId");
  if (userId) {
    fetchUserData(userId)
  }
}, [id])


async function fetchUserData(targetUserId = id || localStorage.getItem("userId")){
  try {
    setLoading(true)
    const res = await ApiCallService.get(`${process.env.REACT_APP_BASE_URL}/user/${targetUserId}`);
    setUserData(res?.data || res)
  }
  catch (err) {
    console.log("Error occured while fetching the data ", err)
  }
  finally {
    setLoading(false)
  }
}


  const [openSections, setOpenSections] = useState({
    "Basic Info.": true,
    "Additional Info.": false,
    "Location Info.": false,
  });

  const navigate = useNavigate()

  const toggleSection = (title) => {
    if (title === "Basic Info.") return;

    setOpenSections((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const fullName = [userData?.userFirstName, userData?.userLastName].filter(Boolean).join(" ") || "User";
  const locationText = [
    userData?.Village?.villageName,
    userData?.Taluka?.talukaName,
    userData?.District?.districtName,
    userData?.Region?.regionName,
    userData?.State?.stateName,
    userData?.Country?.countryName,
  ].filter(Boolean).join(", ") || "—";

  const sections = [
    {
      title: "Basic Info.",
      fields: [
        ["Date of Birth", userData?.dateOfBirth || "—"],
        ["Gender", userData?.gender || "—"],
        ["Email", userData?.emailId || "—"],
        ["Mobile No.", userData?.mobileNumber || "—"],
        ["WhatsApp No.", userData?.whatsAppNumber || userData?.mobileNumber || "—"],
        ["City", userData?.Village?.villageName || userData?.District?.districtName || "—"],
        [
          "Address",
          locationText,
          true,
        ],
      ],
    },
    {
      title: "Additional Info.",
      fields: [
        ["Marital Status", userData?.maritalStatus || "—"],
        ["Education", userData?.education || "—"],
        ["Contributing Since", userData?.contributingSince || "—"],
      ],
    },
    {
      title: "Location Info.",
      fields: [
        ["State", userData?.State?.stateName || userData?.State || "—"],
        ["Region", userData?.Region?.regionName || userData?.Region || "—"],
        ["District", userData?.District?.districtName || userData?.District || "—"],
        ["Taluka", userData?.Taluka?.talukaName || userData?.Taluka || "—"],
        ["Village", userData?.Village?.villageName || userData?.Village || "—"],
      ],
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        boxSizing: "border-box",
        position: "relative",
        isolation: "isolate",
        // px: { xs: 2, sm: 3, md: 4 },
        // py: { xs: 3, sm: 4, md: 5 },
        // background:
        //   "linear-gradient(99deg, rgba(176, 115, 246, 0.4) 0%, rgba(244, 243, 229, 0.55) 35%, rgba(233, 206, 206, 0.7) 100%)",
        background: `
          linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0) 35%,
            rgba(255, 253, 239, 0.2) 37%,
            #ffffff 40%,
            #ffffff 100%
          ),
          linear-gradient(
            99deg,
            rgba(176, 115, 246, 0.45) 0%,
            rgba(244, 243, 229, 0.85) 45%,
            rgba(233, 206, 206, 0.85) 100%
          )
        `,
      }}
    >
      {/* <Box
        sx={{
          width: "100%",
          display: "flex",
          height:"100vh"
        }}
      >
        {Array.from({ length: 16 }).map((_, index) => (
          <Box
            sx={{
              width: "calc(100% / 16)",
              height: "60%",
              position: "relative",
              background:
                "linear-gradient(to right, rgba(255, 248, 248, 0.15), rgba(255, 255, 255, 0.45))",

              "&::after": {
                content: '""',
                position: "absolute",
                inset: 0,
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
                pointerEvents: "none",
              },
            }}
          />
        ))}
      </Box> */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          flexWrap: "nowrap",
          overflow: "hidden",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        {Array.from({ length: 32 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              width: {
                xs: "calc(100% / 6)",
                sm: "calc(100% / 10)",
                md: "calc(100% / 12)",
                lg: "calc(100% / 16)",
                xl: "calc(100% / 20)",
                xxl: "calc(100% / 32)",
              },

              flexShrink: 0,

              height: {
                xs: "30%",
                sm: "40%",
                md: "60%",
              },

              position: "relative",

              background:
                "linear-gradient(to right, rgba(255, 248, 248, 0.15), rgba(255, 255, 255, 0.45))",

              "&::after": {
                content: '""',
                position: "absolute",
                inset: 0,
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
                pointerEvents: "none",
              },
            }}
          />
        ))}
      </Box>
      {/* PAGE HEADER */}
      <Box
        sx={{
          width: "85%",
          mx: "auto",
          zIndex: 1,
          position: "relative",
          justifyContent: "center",
          pt: 5,
          pb: 3,
        }}
      >
        <Box>
          <Button sx={{ minWidth: 0, padding: 0 }} onClick={() => navigate("/dashboard")}><ArrowBack sx={{ color: "rgba(88, 88, 88, 0.55)" }} /></Button>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Typography
              variant="body"
              sx={{
                color: "#25212A",
                fontSize: "29px",
              }}
            >
              Welcome,
            </Typography>
            <Typography
              variant="body"
              sx={{
                color: "#25212A",
                fontSize: "29px",
                fontWeight: 700,
                textAlign: "center",
                ml: 0.5
              }}
            >
              Amit! 👋
            </Typography>
          </Box>
          <Typography
            sx={{
              mt: 0.5,
              color: "#625D67",
              fontSize: { xs: "12px", sm: "14px", md: "16px" },
              fontWeight: 400,
            }}
          >
            Manage your profile, preferences, and more from here.
          </Typography>
        </Box>

        {/* MAIN CARD */}
        <Box
          sx={{
            width: "100%",
            mx: "auto",
            overflow: "visible",
            borderRadius: "10px",
            zIndex: 1,
            position: "relative",
            // border: "2px solid #EEEEF1",
            // boxShadow: "0px 4px 8px rgba(30, 20, 40, 0.08)",
          }}
        >
          {/* PROFILE HEADER */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                my: 2,
                minWidth: 0,
                position: "relative",
              }}
            >
              <Avatar
                src={userData?.userImageURL || image}
                sx={{
                  // position:"absolute",
                  // top:-65,
                  // left:10,
                  alignContent: "flex-start",
                  width: { xs: 65, sm: 120 },
                  height: { xs: 65, sm: 120 },
                  borderRadius: "14px",
                  border: "4px solid #FFFFFF",
                  // boxShadow: "0 0 0 1px #EEEEEE",
                  flexShrink: 0,
                }}
              />

              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    // position:"absolute",
                    // left:150,
                    // top:-18,
                    fontSize: "18px !important",
                    fontWeight: 700,
                    color: "#302b35",
                    whiteSpace: "nowrap",
                  }}
                >
                  {fullName}
                </Typography>

                <Typography
                  sx={{
                    mt: "3px",
                    // position:"absolute",
                    // left:150,
                    // top:5,
                    fontSize: { xs: "7px", sm: "8px", md: "9px" },
                    color: "#625D67",
                    whiteSpace: "nowrap",
                  }}
                >
                  {userData?.userRole || "User"} @ {userData?.District?.districtName || userData?.Region?.regionName || "—"}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ gap: 1 }}>
              <Button
                variant="outlined"
                endIcon={<WorkspacePremiumIcon />}
                sx={{
                  minWidth: "auto",
                  height: "30px",
                  px: 2,
                  borderRadius: "15px",
                  backgroundColor: "#fff",
                  color: "#403A43",
                  fontSize: "14px",
                  fontWeight: 600,
                  textTransform: "none",
                  boxShadow: "0px 4px 4px 0px rgba(100,100,100,0.1)",
                  flexShrink: 0,
                }}
              >
                Get Certificate
              </Button>
              <Button
                variant="outlined"
                endIcon={<SettingsOutlinedIcon />}
                sx={{
                  minWidth: "auto",
                  height: "30px",
                  px: 2,
                  borderRadius: "15px",
                  backgroundColor: "#fff",
                  color: "#403A43",
                  fontSize: "14px",
                  fontWeight: 600,
                  textTransform: "none",
                  boxShadow: "0px 4px 4px 0px rgba(100,100,100,0.1)",
                  flexShrink: 0,
                }}
              >
                Edit
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* INFORMATION SECTIONS */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
          position: "relative",
          isolation: "isolate",
          mb: 8
        }}
      >
        {sections.map((section) => {
          const isBasic = section.title === "Basic Info.";
          const isOpen = openSections[section.title];

          return (
            <Paper
              key={section.title}
              elevation={0}
              sx={{
                width: {
                  xs: "92%",
                  sm: "90%",
                  md: "85%",
                  lg: "85%",
                },
                borderRadius: "10px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #EEEEF1",
                boxShadow: "0px 2px 4px rgba(30, 20, 40, 0.08)",
                overflow: "hidden",
              }}
            >
              {/* SECTION HEADER */}
              <Box
                onClick={() => !isBasic && toggleSection(section.title)}
                sx={{
                  px: { xs: 2, sm: 3, md: 4 },
                  py: { xs: 1.8, sm: 2.2 },

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",

                  cursor: isBasic ? "default" : "pointer",

                  "&:hover": !isBasic
                    ? {
                      backgroundColor: "#FCFAFD",
                    }
                    : {},
                }}
              >
                <Typography
                  sx={{
                    color: "#9B8BA8",
                    fontSize: { xs: "12px", sm: "16px", md: "18px !important" },
                    fontWeight: 600,
                  }}
                >
                  {section.title}
                </Typography>

                {/* Accordion arrow */}
                {!isBasic && (
                  <Typography
                    sx={{
                      color: "#9B8BA8",
                      fontSize: "16px",
                      lineHeight: 1,

                      transform: isOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",

                      transition: "transform 0.2s ease",
                    }}
                  >
                    ⌄
                  </Typography>
                )}
              </Box>

              {/* CONTENT */}
              {isOpen && (
                <Box
                  sx={{
                    px: { xs: 2, sm: 3, md: 4 },
                    pb: { xs: 2.5, sm: 3 },
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(3, 1fr)",
                      },

                      columnGap: {
                        xs: 2,
                        sm: 4,
                        md: 7,
                      },

                      rowGap: {
                        xs: 2,
                        sm: 2.5,
                      },
                    }}
                  >
                    {section.fields.map(([label, value, fullWidth]) => (
                      <Box
                        key={label}
                        sx={{
                          minWidth: 0,

                          gridColumn: {
                            xs: "span 1",
                            sm: fullWidth ? "span 2" : "span 1",
                            md: fullWidth ? "span 3" : "span 1",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            mb: "5px",
                            color: "#25212A",
                            fontSize: {
                              xs: "7px",
                              sm: "8px",
                            },
                            fontWeight: 700,
                            lineHeight: 1.2,
                          }}
                        >
                          {label}
                        </Typography>

                        <Typography
                          sx={{
                            color: "#4D4852",
                            fontSize: {
                              xs: "8.5px",
                              sm: "9px",
                              md: "9.5px",
                            },
                            fontWeight: 400,
                            lineHeight: 1.5,
                            whiteSpace: "pre-line",
                            overflowWrap: "break-word",
                          }}
                        >
                          {value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}
            </Paper>
          );
        })}
      </Box>

    </Box>
  );
};

export default NewViewProfilePage;